/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertId } from './InternalApiAlertId';
import {
    InternalApiAlertIdFromJSON,
    InternalApiAlertIdFromJSONTyped,
    InternalApiAlertIdToJSON,
    InternalApiAlertIdToJSONTyped,
} from './InternalApiAlertId';

/**
 * Alert export parameters
 * @export
 * @interface InternalApiAlertExport
 */
export interface InternalApiAlertExport {
    /**
     * 
     * @type {Array<InternalApiAlertId>}
     * @memberof InternalApiAlertExport
     */
    alerts?: Array<InternalApiAlertId>;
    /**
     * 
     * @type {InternalApiAlertExportTemplateEnum}
     * @memberof InternalApiAlertExport
     */
    template: InternalApiAlertExportTemplateEnum;
    /**
     * External ids of transaction schema fields to include as columns (audit template only)
     * @type {Array<string>}
     * @memberof InternalApiAlertExport
     */
    schemaFieldExternalIds?: Array<string>;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiAlertExportTemplateEnum {
    QA = 'QA',
    AUDIT = 'AUDIT',
    INVESTIGATION = 'INVESTIGATION'
}


/**
 * Check if a given object implements the InternalApiAlertExport interface.
 */
export function instanceOfInternalApiAlertExport(value: object): value is InternalApiAlertExport {
    if (!('template' in value) || value['template'] === undefined) return false;
    return true;
}

export function InternalApiAlertExportFromJSON(json: any): InternalApiAlertExport {
    return InternalApiAlertExportFromJSONTyped(json, false);
}

export function InternalApiAlertExportFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertExport {
    if (json == null) {
        return json;
    }
    return {
        
        'alerts': json['alerts'] == null ? undefined : ((json['alerts'] as Array<any>).map(InternalApiAlertIdFromJSON)),
        'template': json['template'],
        'schemaFieldExternalIds': json['schemaFieldExternalIds'] == null ? undefined : json['schemaFieldExternalIds'],
    };
}

export function InternalApiAlertExportToJSON(json: any): InternalApiAlertExport {
    return InternalApiAlertExportToJSONTyped(json, false);
}

export function InternalApiAlertExportToJSONTyped(value?: InternalApiAlertExport | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alerts': value['alerts'] == null ? undefined : ((value['alerts'] as Array<any>).map(InternalApiAlertIdToJSON)),
        'template': value['template'],
        'schemaFieldExternalIds': value['schemaFieldExternalIds'],
    };
}

